import {
  buildFormData,
  buildQueryString,
  overParseJson,
  checkAttendantAndFetch,
} from '../utils/requestUtils';

const BASE_URL = 'https://afiliados.uol.com.br';
const REPORT_API_URL = `${BASE_URL}/api/report.html`;
const DOWNLOAD_REPORT_URL = `${BASE_URL}/api/downloadAdnetworkReport.html`;
const GENERAL_CPA_REPORT_URL = `${BASE_URL}/api/generalCPAReport.html`;
const HTTP_ERROR = 'HTTP_ERROR';
const DEFAULT_FETCH_OPTIONS = {
  credentials: 'same-origin',
};

class ReportsApi {
  static buildReportPayload(reportOptions) {
    let flag = (reportOptions.reportType === 'DETAILED' && (reportOptions.customLink === true || reportOptions.customLink === 'true')) ? 'nonesites' : '';

    return {
      ajax: true,
      types: reportOptions.products,
      period: reportOptions.period,
      sites: reportOptions.sites,
      identifiers: reportOptions.identifiers,
      'reportRequest.startDate': reportOptions.startDate,
      'reportRequest.endDate': reportOptions.endDate,
      'reportRequest.orderBy': 'datevent',
      'reportRequest.orderType': 'ASC',
      'reportRequest.flag': flag,
    };
  }

  static async getReport(reportOptions) {
    try {
      const payload = buildFormData(this.buildReportPayload(reportOptions));
      const fetchResponse = await checkAttendantAndFetch(REPORT_API_URL, {
        method: 'POST',
        body: payload,
        ...DEFAULT_FETCH_OPTIONS,
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200 || data.error) {
        const error = new Error(data.error.message || data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async downloadReport(reportOptions) {
    try {
      const queryString = buildQueryString(this.buildReportPayload(reportOptions));
      const downloadUrl = `${DOWNLOAD_REPORT_URL}?${queryString}`;

      const fetchResponse = await checkAttendantAndFetch(downloadUrl, {
        method: 'GET',
        ...DEFAULT_FETCH_OPTIONS,
      });

      if (fetchResponse.status !== 200) {
        const res = await fetchResponse.text();
        const error = new Error(overParseJson(res).error.message || fetchResponse.statusText);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return await fetchResponse.blob();
    } catch (error) {
      throw error;
    }
  }

  static async getCPAReport() {
    try {
      const fetchResponse = await checkAttendantAndFetch(GENERAL_CPA_REPORT_URL, {
        method: 'POST',
        body: {
          ajax: true,
        },
        ...DEFAULT_FETCH_OPTIONS,
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const message = data.error ? data.error.message : fetchResponse.statusText;
        const error = new Error(message);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default ReportsApi;
